import { render, staticRenderFns } from "./BreadcrumbSection.vue?vue&type=template&id=6d975210&"
import script from "./BreadcrumbSection.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports